class BpGallery {
	constructor(sel = ".bp-gallery") {
		this.sel = sel;
		this.c = this.component = document.querySelector(this.sel);

		if (!this.c) return;
		this.overlaySection = null;
		this.activeFilter = null;
		this.activeItems = [];
		this.transition = Number(getComputedStyle(this.c).getPropertyValue('--transition')) * 1000;

		// FILTERS

		const filterParent = this.c.querySelector('.filters');
		const [collapseDesktop, collapseMobile] = filterParent.getAttribute('collapse').split(',');

		const filtersWrapper = document.createElement('ul');
		filtersWrapper.setAttribute('collapse-list', '');

		this.filters = {
			wrapper: filtersWrapper,
			parent: filterParent,
			header: filterParent.querySelector('[collapse-header]'),
			nodes: filterParent.querySelectorAll('.filter'),
			collapse: {
				mobile: JSON.parse(collapseMobile),
				desktop: JSON.parse(collapseDesktop)
			}
		}

		const itemsParent = this.c.querySelector('.items');
		this.items = {
			parent: itemsParent,
			nodes: itemsParent.querySelectorAll('.item')
		}

		this.init();

	}

	debounceResize = () => {
		if (this.resizeTick) cancelAnimationFrame(this.resizeTick);
		this.resizeTick = requestAnimationFrame(() => {
			this.handleCollapse();
		});
	}

	get isMobile() { return window.innerWidth < 961 }

	handleCollapse = () => {
		const hasWrapper = this.filters.parent.contains(this.filters.wrapper);

		const willCollapse = this.isMobile && this.filters.collapse.mobile || !this.isMobile && this.filters.collapse.desktop;

		const canWrap = willCollapse && !hasWrapper;
		const canUnwrap = !willCollapse && hasWrapper;

		if (canWrap) {
			this.filters.nodes.forEach(node => this.filters.wrapper.appendChild(node));
			this.filters.parent.appendChild(this.filters.wrapper);
			return;
		}
		if (canUnwrap) {
			this.filters.nodes.forEach(node => this.filters.parent.appendChild(node));
			this.filters.wrapper.remove();
			this.filters.parent.removeAttribute('open');
		}
	}

	sleep = (duration) => new Promise(res => setTimeout(res, duration))

	init = async () => {
		await waitModules(['splide', 'overlay-slider-items']);

		this.toggleFilter(this.filters.nodes[0].getAttribute('category'));

		this.overlaySection = new OverlaySliderItems(this.sel + ' .items', {
			items: '.item.active', overlay: '#overlay',
			forceRefresh: false,
			zoomable: false,
			name: 'gallery'
		});

		this.initFilters();

		this.c.setAttribute('inited', true);


		this.handleCollapse();
		window.addEventListener('resize', this.debounceResize);
	}


	initFilters = () => {
		document.body.addEventListener('click', e => {
			const isFilterClicked = this.filters.parent.contains(e.target);

			if (!isFilterClicked) this.filters.parent.removeAttribute('open');
		})

		this.filters.header.addEventListener('click', e => {
			const isOpen = this.filters.parent.getAttribute('open');
			if (!isOpen) this.filters.parent.setAttribute('open', true)
			else this.filters.parent.removeAttribute('open');
		})

		this.filters.nodes.forEach(filter => {
			filter.addEventListener('click', async (e) => {

				this.toggleFilter(filter.getAttribute('category'));
			})
		})
	}

	refresh = async () => {
		this.c.classList.toggle('error', false);
		this.overlaySection?.refresh(null, null, true);

		if (this.activeItems.length) return await this.setState('done');

		this.c.style.setProperty('--_message', "'No items found'");
		await this.setState('error')
	}

	setState = async (state) => {
		this.c.setAttribute('state', state);
		await this.sleep(this.transition);
	}


	toggleFilter = async (category) => {
		await this.setState('loading');

		this.activeFilter = category;
		this.filters.parent.removeAttribute('open');

		this.filters.nodes.forEach(filter => {
			const isActive = filter.getAttribute('category') === this.activeFilter;
			console.log(filter.getAttribute('category'), this.activeFilter)
			filter.classList.toggle('active', isActive);

			if (!isActive) return;

			const textNode = this.filters.header.querySelector('label');
			if (textNode) textNode.innerHTML = filter.innerHTML;
		});

		// 2. Filtrar ítems por categoría
		this.activeItems = [];
		this.items.nodes.forEach(item => {
			const matchesCategory = this.activeFilter === 'all' || item.getAttribute('category') === this.activeFilter;
			item.classList.toggle('active', matchesCategory); // .active = pertenece a la categoría
			if (matchesCategory) this.activeItems.push(item);
		});

		await this.refresh();
	}

}
new BpGallery();
